import React, {Component} from 'react';
import * as firebase from 'firebase';
import FontAwesome from 'react-fontawesome';
import ImageUploader from '../image-uploader/image-uploader';
import RichTextArea from '../rich-text-area/rich-text-area';

export default class Product extends Component {
  /** @constructor
    * Creates a new instance of a ProductEditor
    */
  constructor(props){
    super(props);
    this.dataURL = `/expos/${this.props.expoID}/products/${this.props.productID}`;
    this.firebaseRef = firebase.database().ref(this.dataURL);
    this.state = {
      name: "",
      manufacturer: "",
      showcase: false,
      description: '',
      vendors: []
    }
    this.handleChange = this.handleChange.bind(this);
    this.handleImageUpload = this.handleImageUpload.bind(this);
    this.handleTextChange = this.handleTextChange.bind(this);
    this.handleVendorDataChange = this.handleVendorDataChange.bind(this);
    this.handleAddVendor = this.handleAddVendor.bind(this);
    this.handleRemoveVendor = this.handleRemoveVendor.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
  }
  /** @method componentWillMount
    */
  componentWillMount() {
    this.firebaseRef.on('value', snapshot => {
      this.setState(snapshot.val());
    });
  }
  componentWillUnmount() {
    this.firebaseRef.off();
  }
  /** @function handleChange
    * Applies user changes to the state
    * @param {InputEvent} event - the triggering event
    */
  handleChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    this.setState({
      [name]: value
    });
  }
  handleImageUpload(name, url) {
    this.setState({
      [name]: url
    }, () => this.handleBlur());
  }
  handleTextChange(html) {
    this.setState({
      'description': html
    }, () => this.handleBlur());
  }
  handleVendorDataChange(index, event) {
    const value = event.target.value;
    const name = event.target.name;
    var vendors = this.state.vendors;
    vendors[index][name] = value;
    this.setState({
      vendors: vendors
    });
  }
  handleAddVendor() {
    var vendors = this.state.vendors;
    vendors.push({text: 'vendor', url: 'new purchase url'});
    this.setState({vendors: vendors});
  }
  handleRemoveVendor(index) {
    var vendors = this.state.vendors;
    vendors.splice(index, 1);
    this.setState({vendors: vendors});
  }
  /** @function handleBlur
    * Applies the current state to the database
    */
  handleBlur() {
    this.firebaseRef.set(this.state);
  }
  render() {
    var vendorRows = this.state.vendors.map((vendor, index) => (
      <tr key={index}>
        <td>{index+1}</td>
        <td>
          <input name="name" type="name"
            value={vendor.name}
            onChange={event => this.handleVendorDataChange(index, event)}
            onBlur={this.handleBlur}
            />
        </td>
        <td>
          <input name="url" type="url"
            value={vendor.url}
            onChange={event => this.handleVendorDataChange(index, event)}
            onBlur={this.handleBlur}
            />
        </td>
        <td>
          <FontAwesome name="times"
            style={{color: 'red'}}
            onClick={()=>this.handleRemoveVendor(index)}/>
        </td>
      </tr>
    ));
    return (
      <div className="product-editor">
        <h1>Product Editor</h1>
        <div className="metadata-panel">
          <div className="metadata-column">
            <div className="input-group">
              <label htmlFor="name">Name</label><br/>
              <input type="text" name="name"
                value={this.state.name}
                onChange={this.handleChange}
                onBlur={this.handleBlur}
                />
            </div>
            <div className="input-group">
              <label htmlFor="name">Manufacturer</label><br/>
              <input type="text" name="manufacturer"
                value={this.state.manufacturer}
                onChange={this.handleChange}
                onBlur={this.handleBlur}
                />
            </div>
            <div className="input-group">
              <label htmlFor="showcase">
                <input type="checkbox" name="showcase"
                  checked={this.state.showcase}
                  onChange={this.handleChange}
                  onBlur={this.handleBlur}
                  />
                  include in showcase
              </label>
            </div>
            <div className="input-group">
              <ImageUploader
                name="Product Image"
                value={this.state.image}
                dataURL={this.props.dataURL + '/image'}
                onUpload={(url)=>this.handleImageUpload('image', url)}
                />
            </div>
          </div>
          <div className="metadata-column">
            <div className="input-group">
              <label>Description</label><br />
              <RichTextArea value={this.state.description}
                onChange={this.handleTextChange}
                />
            </div>
            <div className="input-group">
              <label>Buy it Now Vendors</label>
              <table>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Vendor Name</th>
                    <th>Purchase URL</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {vendorRows}
                </tbody>
              </table>
              <button onClick={this.handleAddVendor} style={{marginTop: '1rem', color: 'green'}}>
                <FontAwesome name="plus" />
                Add Vendor
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/product-editor/product-editor.js